import React, { useState } from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';

import { AD_ENTITY_TYPES } from '@silverfort-nodelibs/common/utils/consts';
import { SELECTOR_TYPE } from '../common/selectorsConsts';
import SelectedEntitiesContainer from '../common/SelectedEntitiesContainer';
import IpInputContainer from '../common/IpInputContainer';
import styles from './IpsSelector.module.css';
import { addIpsFromFile, isIpSubnetValid } from '../../../utils';

const IpsSelector = ({
    modalTitle,
    selectedIps,
    showModal,
    handleCloseModal,
    saveIps,
    showExcluded,
    maxIps,
    maxFileSize,
    maxFileSizeText,
    isEditor = true
}) => {
    const [fileError, setFileError] = useState('');
    const [fileLoading, setFileLoading] = useState(false);
    const [currentSelectedIps, setCurrentSelectedIps] = useState(
        selectedIps.map((ipObj) => {
            return { ...ipObj, type: AD_ENTITY_TYPES.IP };
        })
    );

    const onRemoveSelected = (index) => {
        const newSelectedIps = [...currentSelectedIps];
        newSelectedIps.splice(index, 1);
        setCurrentSelectedIps(newSelectedIps);
    };

    const closeSelector = () => {
        if (handleCloseModal) {
            handleCloseModal();
        }
    };

    const onSaveIpsClicked = () => {
        if (saveIps) {
            saveIps(currentSelectedIps);
        }
    };

    const addIp = (newIp) => {
        let isAdded = false;
        setCurrentSelectedIps((currentSelectedIps) => {
            const sameSelected = currentSelectedIps.find(
                (selectedIp) => selectedIp.address === newIp.address && selectedIp.mask === newIp.mask
            );
            if (
                sameSelected ||
                !isIpSubnetValid(newIp.address, newIp.mask) ||
                (maxIps && maxIps === currentSelectedIps.length)
            ) {
                return currentSelectedIps;
            }
            isAdded = true;
            return [...currentSelectedIps, newIp];
        });
        return isAdded;
    };

    const onFileUploaded = (file, exclude = false) => {
        addIpsFromFile(file, addIp, setFileError, setFileLoading, maxFileSize, maxFileSizeText, exclude);
    };

    return (
        <div className={styles.modalContainer}>
            <Modal
                id={styles.ipsSelectorModal}
                show={showModal}
                onHide={closeSelector}
                keyboard={true}
                className="z-[5000]"
                backdropClassName="z-[5000]"
                backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>{modalTitle ? modalTitle : 'Select Ip /Subnet'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <IpInputContainer
                            addIp={addIp}
                            showExcluded={showExcluded}
                            disabledAdd={maxIps && maxIps === currentSelectedIps.length}
                            maxIps={maxIps}
                        />
                        <SelectedEntitiesContainer
                            selectedEntities={currentSelectedIps}
                            onRemoveSelected={onRemoveSelected}
                            selectorType={SELECTOR_TYPE.IP}
                            onFileUploaded={onFileUploaded}
                            fileLoading={fileLoading}
                            showExcluded={showExcluded}
                        />
                        {fileError && (
                            <div className={styles.error}>
                                <span>{fileError}</span>
                            </div>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className={styles.footerButtons}>
                        <Button onClick={closeSelector}>Cancel</Button>
                        <Button bsStyle="success" onClick={onSaveIpsClicked} disabled={!isEditor}>
                            Done
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default IpsSelector;
